<template>
  <div>
    <v-btn
      class="settings-btn"
      @click="sheet = true"
      absolute
      dark
      fixed
      v-show="display"
      v-if="!isInstaller()"
      fab
      bottom
      right
      color="primary"
    >
      <v-icon>settings</v-icon>
    </v-btn>
    <v-dialog width="450px" v-model="sheet">
      <v-card class="mx-auto">
        <v-btn @click="sheet = !sheet" class="close-btn" flat icon color="#757575" absolute right>
          <v-icon class="close-icon">close</v-icon>
        </v-btn>
        <v-card-title class="installers-title" primary-title>
          Seleccionar instaladores
        </v-card-title>
        <v-card-text>
          <v-layout column>
            <v-checkbox
              v-for="(installer, i) in installers" :key="i"
              v-model="installer.value"
              :label="installer.text"
              :style="{ color: installer.color }"
              @change="onChangeInstallers"
            ></v-checkbox>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container v-if="(isSuperadmin() || isAdmin()) && !isNew()" fluid class="pa-0">

      <v-layout class="column avatar-info" align-center justify-center>
        <v-flex xs12 sm6 class="py-2">
          <v-btn-toggle v-model="selectedTool" mandatory>
            <v-btn flat>
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn flat>
              <v-icon>block</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
      <br>
    </v-container>
    <v-spacer></v-spacer>
    <vue-calendar
      ref="calendar"
      :config="config"
      :events="events"
      @event-click="eventClick"
      @event-double-click="eventDoubleClick"
      @select="select"
    ></vue-calendar>
    <div class="text-xs-center">
      <v-dialog
        v-if="current"
        v-model="dialog"
        max-width="500"
      >
        <v-card>
          <v-toolbar :style="{ backgroundColor: current.color, color: 'white', height: '72px' }" light >
            <v-btn
              fab
              small
              light
              :style="{ backgroundColor: 'white', color: current.color }"
              bottom
              left
              absolute
              @click="openBooking(current.identificator)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <template v-slot:extension>
              <div class="the-title">
                {{ current. title }}
              </div>
            </template>
            <v-spacer></v-spacer>
            <v-btn :style="{ marginRight: '6px', marginTop: '-10px' }" flat icon color="white" @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-list two-line>
              <v-list-tile @click="showPlainText()">
                <v-list-tile-action>
                  <v-icon :style="{ color: current.color }">calendar_today</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ current.date }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="showPlainText()">
                <v-list-tile-action>
                  <v-icon :style="{ color: current.color }">location_on</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="multiline">{{ current.address }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="showPlainText()">
                <v-list-tile-action>
                  <v-icon :style="{ color: current.color }">build</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="multiline">{{ current.installer }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="showPlainText()">
                <v-list-tile-action>
                  <v-icon :style="{ color: current.color }">face</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="multiline">{{ current.customer }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="showPlainText()">
                <v-list-tile-action>
                  <v-icon :style="{ color: current.color }">store</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="multiline">{{ current.commerce }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="showPlainText()">
                <v-list-tile-action>
                  <v-icon :style="{ color: current.color }">settings_input_component</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="multiline">{{ current.model }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="showPlainText()">
                <v-list-tile-action>
                  <v-icon :style="{ color: current.color }">attach_money</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="multiline">{{ current.payment_method }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="current"
        v-model="flatDialog"
        max-width="750"
      >
        <v-card :style="{ padding: '5px 38px' }">
          <v-btn :style="{ color: '#9e9e9e', float: 'right', marginRight: '-31px', marginTop: '0px' }" flat icon @click="flatDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-card-text><br><br>
            <div :style="{ fontSize: '22px' }"><b>{{ current.title }}</b></div>
            {{ current.subtitle }}<br>
            {{ current.anexo }}<br><br>
            -----------------------------------------------------------------------------------------------------------<br><br>
            {{ current.phones }} - {{ current.customer }} - {{ current.dni }}<br>
            {{ current.customer_email }}<br>
            {{ current.address }}<br>
            {{ current.invoiceInfo }}<br><br>
            -----------------------------------------------------------------------------------------------------------<br><br>
            {{ current.equipment }}<br><br>
            -----------------------------------------------------------------------------------------------------------<br><br>
            <b>OBSERVACIONES</b>:<br><br>
            {{ current.observations }}<br><br>
            {{ current.booking_observations }}<br><br>
            -----------------------------------------------------------------------------------------------------------<br><br>
            <b>SE HA PAGADO</b>: {{ current.wasPaid }}<br><br>
            <b>NO SE COBRA</b>: {{ current.notPaid }}<br><br>
            <b>A COBRAR</b>: {{ current.toPaid }}<br><br>

          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
  'use strict'

  import moment from 'moment'
  import VueCalendar from '@/components/vue-calendar'
  export default {

    name: 'Calendar',

    components: {
      VueCalendar
    },

    data: () => ({
      events: [],
      config: {
        buttonText: {
          today: 'hoy',
          month: 'mes',
          week: 'semana',
          day: 'día',
          list: 'lista'
        },
        views: {
          month: {
            columnFormat: 'dddd'
          },
          week: {
            columnFormat: 'ddd D/M'
          },
          day: {
            columnFormat: 'dddd D/M'
          }
        },
        slotLabelFormat: 'HH:mm',
        allDayText: 'todo el día',
        allDaySlot: false,
        scrollTime: '08:00:00',
        defaultView: 'month',
        editable: false,
        selectable: true,
        droppable: false,
        locale: 'es',
        hiddenDays: [0]
      },
      sheet: false,
      on: false,
      selected: {},
      deactivatedShedules: [],
      installers: [],
      shedules: [],
      startDate: '',
      current: null,
      clickTimer: null,
      endDate: '',
      dialog: false,
      display: false,
      flatDialog: false,
      humanizeDate: '',
      selectedTool: 1
    }),

    created () {
      if (!this.isNew()) {
        this.getCalendarShedules()
      } else {
        this.config.header = {
          right: ' '
        }
        this.config.selectable = false
      }
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCalendarShedules () {
        if (this.display) {
          this.removeEvents()
        }
        let selectedInstallers = this.getSelectedInstallers()
        this.config.displayEventTime = false
        if (this.isAdmin() || this.isSuperadmin() || this.isInstaller()) {
          this.config.defaultView = 'agendaWeek'
        }
        this.getDeactivatedShedules().then((response) => {
          this.getBookings(this.$store.getters['api/getUserRol'], selectedInstallers).then((response) => {
            console.log(this.getUnique(response.data.items, 'commerce_id'))
            this.installers.forEach((item) => {
              let val = !this.hasSelected() ? true : item.value
              if (val) {
                this.getDeactivatedShedulesForInstallers(item.user_id).then((response) => {
                  this.display = true
                  // console.log(response)
                }).catch((error) => {
                  console.log(error)
                  this.$store.dispatch(
                    'snackbar/show',
                    'Error al obtener los días ocupados: ' + this.$store.getters['api/getMessage']
                  )
                })
              }
            })
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener las reservas: ' + this.$store.getters['api/getMessage']
            )
          })
        }).catch((error) => {
          console.log(error)
          this.$store.dispatch(
            'snackbar/show',
            'Error al obtener los días ocupados: ' + this.$store.getters['api/getMessage']
          )
        })
      },

      getUnique (array, key) {
        const unique = array.map(e => e[key])
          .map((e, i, final) => final.indexOf(e) === i && i)
          .filter(e => array[e]).map(e => array[e])

        return unique
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isNew () {
        return this.$route.params.booking_id === 'new'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      copy () {
        let text = this.getPlainText()
        let dummy = document.createElement('textarea')
        document.body.appendChild(dummy)
        dummy.value = text
        dummy.select()
        document.execCommand('copy')
        document.body.removeChild(dummy)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getPlainText () {
        return '' +
        this.current.title.replace(/(\r\n|\n|\r)/gm, '') + '\n' +
        this.current.subtitle.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' +
        this.current.anexo.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' +
        '-----------------------------------------------------------------------------------------------------------\n\n' +
        (this.current.phones + ' - ' + this.current.customer + ' - ' + this.current.dni).replace(/(\r\n|\n|\r)/gm, '') + '\n' +
        this.current.customer_email.replace(/(\r\n|\n|\r)/gm, '') + '\n' +
        this.current.address.replace(/(\r\n|\n|\r)/gm, '') + '\n' +
        this.current.invoiceInfo.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' +
        '-----------------------------------------------------------------------------------------------------------\n\n' +
        this.current.equipment.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' +
        '-----------------------------------------------------------------------------------------------------------\n\n' +
        'OBSERVACIONES: \n\n' +
        this.current.observations.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' +
        this.current.booking_observations.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' +
        '-----------------------------------------------------------------------------------------------------------\n\n' +
        'SE HA PAGADO: ' + this.current.wasPaid.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' +
        'NO SE COBRA: ' + this.current.notPaid.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' +
        'A COBRAR: ' + this.current.toPaid.replace(/(\r\n|\n|\r)/gm, '')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isSuperadmin () {
        return this.$store.getters['api/getUserRol'] === 'superadmin'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isAdmin () {
        return this.$store.getters['api/getUserRol'] === 'administrator'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isInstaller () {
        return this.$store.getters['api/getUserRol'] === 'installer'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeInstallers () {
        clearTimeout(this.clickTimer)
        this.clickTimer = setTimeout(() => {
          this.getCalendarShedules()
        }, 1000)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      showPlainText () {
        this.copy()
        this.flatDialog = true
        this.$awn.success('Se ha copiado automáticamente este texto en tu portapapeles.')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      eventDoubleClick (event) {
        if (!this.isNew()) {
          if (event.status === 12) {
            this.deleteDeactivatedShedule(event)
          } else {
            this.current = event
            this.openBooking(this.current.identificator)
          }
        } else {
          this.addBooking(event)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      eventClick (event) {
        if (!this.isNew()) {
          if (event.status === 12) {
            this.deleteDeactivatedShedule(event)
          } else {
            // this.openBooking(event.identificator)
            // console.log(this.current)
            this.current = event
            this.dialog = true
          }
        } else {
          this.addBooking(event)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addBooking (event) {
        this.$emit(
          'on-assign-booking',
          event.identificator,
          moment(event.start).format('YYYY-MM-DD HH:mm'),
          moment(event.end).format('YYYY-MM-DD HH:mm')
        )
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      refreshEvents () {
        this.$refs.calendar.refreshEvents()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      removeEvents () {
        this.$refs.calendar.removeEvents()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openBooking (saleID) {
        this.$router.push({
          name: 'booking-id',
          params: {
            booking_id: saleID
          }
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      newBooking () {
        this.$router.push({
          name: 'booking-new',
          params: {
            booking_id: 'new',
            booking_start: moment(this.startDate).format('YYYY-MM-DD_HH:mm'),
            booking_end: moment(this.endDate).format('YYYY-MM-DD_HH:mm')
          }
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      humanize (startDate, endDate) {
        return 'Desde el ' + moment(this.startDate).format('DD-MM-YYYY') + ' a las ' + moment(this.startDate).format('HH:mm') + ' hasta el ' + moment(this.endDate).format('DD-MM-YYYY') + ' a las ' + moment(this.endDate).format('HH:mm') + '.'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      select (startDate, endDate) {
        if (this.isNew()) {
          return true
        }
        this.startDate = startDate
        this.endDate = endDate
        this.humanizeDate = this.humanize()
        if (this.isInstaller()) {
          this.addDeactivatedShedule()
        } else if ((this.isSuperadmin() || this.isAdmin())) {
          if (this.selectedTool === 0) {
            this.newBooking()
          } else if (this.selectedTool === 1) {
            this.addDeactivatedShedule()
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getColorByState (status) {
        let color = ''
        switch (status) {
          case 6:
          case '6':
            color = '#3F51B5'
            break
          case 7:
          case '7':
            color = '#673ab7'
            break
          case 8:
          case '8':
            color = '#f44336'
            break
          case 9:
          case '9':
            color = '#ff9800'
            break
          case 10:
          case '10':
            color = '#009688'
            break
          case 11:
          case '11':
            color = '#00897b'
            break
          case 12:
          case '12':
            color = '#9e9e9e'
            break
          case 13:
          case '13':
            color = '#2196f3'
            break
          case 14:
          case '14':
            color = '#8bc34a'
            break
          default:
            color = '#009688'
            break
        }
        return color
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getStatusName (status) {
        let text = ''
        switch (status) {
          case 6:
          case '6':
            text = 'Pendiente'
            break
          case 7:
          case '7':
            text = 'En proceso'
            break
          case 8:
          case '8':
            text = 'Cancelada'
            break
          case 9:
          case '9':
            text = 'Anulada'
            break
          case 10:
          case '10':
            text = 'Finalizada'
            break
          case 11:
          case '11':
            text = 'Finalizada'
            break
          case 12:
          case '12':
            text = 'OCUPADO'
            break
          case 13:
          case '13':
            text = 'Cita programada'
            break
          case 14:
          case '14':
            text = 'No instalada por iBEC'
            break
          default:
            text = status
            break
        }
        return text
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      renderShedules (element) {
        if (element.items) {
          element.items.forEach((item, index) => {
            this.$refs.calendar.fireMethod('render-event', {
              id: Date.now(),
              identificator: item[element.item_value],
              status: item[element.item_text_3] || 12,
              title: this.getStatusName(item[element.item_text_3] || 12),
              start: item[element.item_text],
              end: item[element.item_text_2],
              overlap: true,
              color: this.getInstallerColorByUserId(item.user_id) || this.getColorByState(item[element.item_text_3] || 12)
            }, true)
          })
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      renderCustomShedules (element) {
        if (element.items) {
          element.items.forEach((item, index) => {
            let i = this.installers.findIndex(installer => parseInt(installer.id) === parseInt(item.installer_id))
            if (!this.display && i === -1) {
              this.installers.push({
                text: item.custom_installer_alias === '' ? 'Sin asignar' : item.custom_installer_alias,
                id: parseInt(item.installer_id),
                value: true,
                user_id: item.custom_installer_user_id,
                color: item.installer_color || this.getColorByState(6)
              })
            }
            this.$refs.calendar.fireMethod('render-event', {
              id: Date.now(),
              identificator: item.booking_id,
              status: item.status_id || 12,
              title: this.getTitle(item),
              subtitle: this.getSubTitle(item),
              anexo: this.getAnexo(item),
              start: item.booking_installation_start_date,
              end: item.booking_installation_end_date,
              overlap: true,
              color: this.isSuperadmin() || this.isAdmin() ? (item.installer_color || this.getColorByState(item.status_id || 12)) : this.getColorByState(item.status_id || 12),
              date: this.getDate(item),
              address: this.getAddress(item),
              installer: this.getInstallerAlias(item),
              customer: this.getCustomerName(item),
              customer_email: this.getCustomerEmail(item),
              commerce: this.getCommerceAlias(item),
              model: this.getBrandAndModel(item),
              phones: this.getCustomerPhones(item),
              dni: this.getCustomerDni(item),
              equipment: this.getEquipment(item),
              observations: this.getObservations(item),
              payment_method: this.getPaymentMethod(item),
              booking_observations: this.getBookingObservations(item),
              wasPaid: this.getWasPaid(item),
              notPaid: this.getNotPaid(item),
              toPaid: this.getToPaid(item),
              invoiceInfo: this.getInvoiceInfo(item)
            }, true)
          })
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getSaleId (item) {
        return (item.booking_id || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getPaymentMethod (item) {
        return (item.custom_payment_method || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getNotPaid (item) {
        return (item.custom_not_paid || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getToPaid (item) {
        return (item.custom_to_paid || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInvoiceNumber (item) {
        return (item.custom_invoice_number || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getWasPaid (item) {
        return (item.custom_was_paid || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getBrandAndModel (item) {
        return (item.custom_brand || '') + ' ' + (item.custom_model || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getBookingObservations (item) {
        return (item.custom_booking_observations || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getObservations (item) {
        return (item.custom_observations || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getEquipment (item) {
        return (item.custom_equipment || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCustomerPhones (item) {
        return (item.custom_phones || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCommerceName (item) {
        return (item.commerce_name || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCustomerDni (item) {
        return (item.customer_dni || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCustomerEmail (item) {
        return (item.customer_email || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCustomerName (item) {
        return (item.customer_name || '') + ' ' + (item.customer_surname || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInstallerAlias (item) {
        return (item.installer_alias || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCommerceAlias (item) {
        return (item.commerce_alias || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInvoiceInfo (item) {
        let date = (item.custom_start_date || ' - - ').split('-')
        // return (item.custom_start_date || '') + ' - ' +
        return this.getSaleId(item) + ' - ' +
               this.getInvoiceNumber(item) + ' - ' +
               date[0] + '/' + date[1] + ' - ' +
               (item.customer_name || '') + ' ' + (item.customer_surname || '')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getAnexo (item) {
        let date = (item.custom_start_date || ' - - ').split('-')
        // return (item.custom_start_date || '') + ' - ' +
        return date[2] + '-' + date[1] + '-' + date[0] + ' - ' +
               ' ANEXO VI - ' +
               (item.customer_name || '') + ' ' + (item.customer_surname || '') + ' - ' +
               this.getCommerceAlias(item)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getTitle (item) {
        return this.getSaleId(item) + ' - ' +
               (item.custom_today || '') + ' - ' +
               (item.custom_start_date || '') + ' - ' +
               (item.custom_start_hour || '') + 'h - ' +
               this.getInstallerAlias(item) + ' - ' +
               (item.customer_name || '') + ' ' + (item.customer_surname || '') + ' - ' +
               this.getCommerceAlias(item)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getSubTitle (item) {
        let hour = item.custom_start_hour.split(':')
        return (item.custom_start_date || '') + ' - ' +
               (hour[0] || '') + 'h - ' +
               this.getSaleId(item) + ' - ' +
               this.getInstallerAlias(item) + ' - ' +
               (item.customer_name || '') + ' ' + (item.customer_surname || '') + ' - ' +
               this.getCommerceAlias(item)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getDate (item) {
        return (item.custom_today || '') + ' - ' +
               (item.custom_start_date || '') + ' - ' +
               (item.custom_start_hour || '') + 'h'
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getAddress (item) {
        return (item.customer_delivery_address || '') + ' ' +
               (item.customer_delivery_address_2 || '') + ', ' +
               (item.customer_delivery_postal_code || '') + ', ' +
               (item.customer_delivery_locality || '') + ', ' +
               (item.customer_delivery_province || '')
        // return this.getStatusName(item.status_id || 12) +
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getBookings (type, selectedInstallers) {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'get-all/bookings/' + userID + '/' + type + '/' + (selectedInstallers.join() || 'false') + '/'
          }).then((response) => {
            this.shedules = response.data
            this.isNew() ? this.renderShedules(this.shedules) : this.renderCustomShedules(this.shedules)
            console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener calendario: ' + this.$store.getters['api/getMessage']
            )
            reject(error)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getDeactivatedShedulesForInstallers (userID) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'deactivated-shedules/' + userID + '/'
          }).then((response) => {
            let id = parseInt(this.$store.getters['api/getUserId'])
            if (this.isAdmin() || this.isSuperadmin() || (this.isInstaller && userID === id)) {
              this.renderShedules(response.data)
            }
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener calendario: ' + this.$store.getters['api/getMessage']
            )
            reject(error)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      hasSelected () {
        let active = false
        this.installers.forEach((item) => {
          if (item.value) {
            active = true
          }
        })
        return active
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInstallerColorByUserId (userID) {
        let i = this.installers.findIndex(installer => parseInt(installer.user_id) === parseInt(userID))
        if (i > -1) {
          return this.installers[i].color
        }
        return null
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getDeactivatedShedules () {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          // console.log(userID)
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'deactivated-shedules/' + userID + '/'
          }).then((response) => {
            this.renderShedules(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener calendario: ' + this.$store.getters['api/getMessage']
            )
            reject(error)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addDeactivatedShedule () {
        let assignTo = []
        if (this.isSuperadmin() || this.isAdmin()) {
          let selectedInstallers = this.getSelectedInstallers()
          if (selectedInstallers.length) {
            this.installers.forEach((item) => {
              if (item.value && parseInt(item.user_id) !== 2) {
                assignTo.push({
                  id: item.user_id
                })
              }
            })
          }
        }

        if (!assignTo.length) {
          assignTo.push({
            id: parseInt(this.$store.getters['api/getUserId'])
          })
        }

        assignTo.forEach((item) => {
          this.$store.dispatch('api/authRequest', {
            method: 'post',
            url: 'deactivated-shedules/' + item.id + '/',
            data: {
              start: moment(this.startDate).format('YYYY-MM-DD HH:mm:ss'),
              end: moment(this.endDate).format('YYYY-MM-DD HH:mm:ss')
            }
          }).then((response) => {
            console.log(response.data)
            let event = {
              id: Date.now(),
              identificator: response.data.id,
              status: 12,
              title: this.getStatusName(12),
              start: this.startDate,
              end: this.endDate,
              overlap: true,
              color: this.getInstallerColorByUserId(response.data.user_id) || this.getColorByState(12)
            }
            this.$refs.calendar.renderEvent(event, true)
            this.$awn.success('Horario agregado')
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error al agregar observación: ' + message)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getSelectedInstallers (event) {
        let selected = []
        this.installers.forEach((item) => {
          if (item.value) {
            selected.push(item.id)
          }
        })

        return selected
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteDeactivatedShedule (event) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'deactivated-shedules/' + event.identificator + '/'
        }).then((response) => {
          // console.log(response)
          this.$refs.calendar.removeEvent(event)
          this.$awn.success('Horario eliminado')
        }).catch(() => {
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al eliminar el horario: ' + message)
        })
      }
    },
    computed: {
      dddd () {
      }
    }
  }
</script>


<style lang="sass">

$subtract: 'http://localhost:8088/app/public/subtract-icon.png'

$add: 'http://localhost:8088/app/public/add-icon.png'

$disable: 'http://localhost:8088/app/public/disable-icon.png'

.fc-sun
  background: #eee

.vc-icon
  height: 24px
  width: 24px

.add
  background-image: url($add)

.subtract
  background-image: url($subtract)

.disable
  background-image: url($disable)

.installers-title
  padding-top: 24px
  color: rgba(0,0,0,0.54)
  font-size: 17px

.actions-card
  width: 100%
  text-align: right
  top: 0px
  right: 0px
  position: absolute

.the-title
  font-size: 21px
  padding-left: 86px
  margin-top: 15px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  width: -webkit-fill-available;

.multiline
  white-space: unset !important
  overflow: unset !important

.settings-btn
  margin-bottom: 48px

.close-btn
  margin-top: 4px
  margin-right: -11px
</style>


// WEBPACK FOOTER //
// src/components/calendar.vue